import { render, staticRenderFns } from "./ChartReceita.vue?vue&type=template&id=1303b80f"
import script from "./ChartReceita.vue?vue&type=script&lang=js"
export * from "./ChartReceita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports